<template>
	<v-data-table :items="items" :headers="headers" class="elevation-0 new-back lighten2">
		<template #item.preview="{ item }">
			<code class="text-caption">...{{ item.preview }}</code>
		</template>
		<template #item.expirationDateTime="{ item }">
			<span v-if="item.expirationDateTime">
				{{ item.expirationDateTime | formatDate }}
			</span>
			<span v-else class="grey--text">Never</span>
		</template>
		<template #item.lastUsedDateTime="{ item }">
			<span v-if="item.lastUsedDateTime">{{ item.lastUsedDateTime | formatDateTime }}</span>
			<span v-else class="grey--text">Never</span>
		</template>
		<template #item.createdDateTime="{ item }">
			{{ item.createdDateTime | formatDate }}
		</template>
		<template #item.createdByFullName="{ item }">
			<span v-if="item.createdByFullName">
				{{ item.createdByFullName }}
				<span v-if="item.createdByBlueTag" class="grey--text text--lighten-1">
					({{ item.createdByBlueTag }})
				</span>
			</span>
			<span v-else class="grey--text">N/A</span>
		</template>
		<template #item.permissions="{ item }">
			<template v-if="item.permissions && item.permissions.length > 0">
				<v-chip v-for="(perm, idx) in item.permissions" :key="idx" small class="mr-1 mb-1" outlined>
					{{ getPermissionName(perm.type) }}: {{ getAccessLevelName(perm.accessLevel) }}
				</v-chip>
			</template>
			<span v-else class="grey--text">No permissions</span>
		</template>
		<template #item.actions="{ item }">
			<v-menu v-if="item.status === 0 && $security.can('edit')" left offset-x>
				<template #activator="{ on }">
					<v-btn v-on="on" icon><v-icon>mdi-dots-vertical</v-icon></v-btn>
				</template>
				<v-list dense class="py-1">
					<v-list-item @click="editToken(item)" class="pa-1 py-0">
						<v-btn text small color="primary">
							<v-icon left>mdi-pencil</v-icon>
							Edit
						</v-btn>
					</v-list-item>
					<v-list-item @click="revokeToken(item)" class="pa-1 py-0">
						<v-btn text small color="error">
							<v-icon left>mdi-cancel</v-icon>
							Revoke
						</v-btn>
					</v-list-item>
				</v-list>
			</v-menu>
		</template>
	</v-data-table>
</template>

<script>

export default {
	props: {
		items: {
			type: Array,
			required: true
		},
		permissions: {
			type: Array,
			required: true
		}
	},
	data: () => ({
    headers: [
      { text: "Name", value: "name" },
      { text: "Description", value: "description" },
      { text: "Token", value: "preview" },
      { text: "Expires At", value: "expirationDateTime" },
      { text: "Last Used", value: "lastUsedDateTime" },
      { text: "Created At", value: "createdDateTime" },
      { text: "Created By", value: "createdByFullName" },
      { text: "Permissions", value: "permissions" },
      { text: "", value: "actions", width: "1" },
    ],
	}),
	methods: {
    getPermissionName(type) {
      const permissionsBase = this.permissions
        .map(x => x.children ? x.children : x)
        .flat(1);
      const perm = permissionsBase.find(p => p.value === type);
      return perm ? perm.name : `Type ${type}`;
    },
    getAccessLevelName(level) {
      const levelNames = {
        0: 'Default',
        1: 'Not Allowed',
        2: 'List',
        3: 'Detail',
        4: 'Add',
        5: 'Edit',
        6: 'Full Access'
      };
      return levelNames[level] || 'Unknown';
    },
		editToken(item) {
			this.$emit('edit', item);
		},
		revokeToken(item) {
			this.$http.delete(`/api/apiToken/${item.id}`)
				.then(res => {
					this.$emit('revoke', item);
				})
				.catch(res => {
					window.getApp.error("Cannot revoke API token.");
					console.log(res);
				});
		}
	}
}
</script>